/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePaymentInfoResponseDto
 */
export interface UpdatePaymentInfoResponseDto {
    /**
     * The URL for the payment info update login page
     * @type {string}
     * @memberof UpdatePaymentInfoResponseDto
     */
    loginUrl: string;
    /**
     * The Stripe Connect account ID
     * @type {string}
     * @memberof UpdatePaymentInfoResponseDto
     */
    accountId: string;
}

/**
 * Check if a given object implements the UpdatePaymentInfoResponseDto interface.
 */
export function instanceOfUpdatePaymentInfoResponseDto(value: object): value is UpdatePaymentInfoResponseDto {
    if (!('loginUrl' in value) || value['loginUrl'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    return true;
}

export function UpdatePaymentInfoResponseDtoFromJSON(json: any): UpdatePaymentInfoResponseDto {
    return UpdatePaymentInfoResponseDtoFromJSONTyped(json, false);
}

export function UpdatePaymentInfoResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePaymentInfoResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'loginUrl': json['loginUrl'],
        'accountId': json['accountId'],
    };
}

export function UpdatePaymentInfoResponseDtoToJSON(json: any): UpdatePaymentInfoResponseDto {
    return UpdatePaymentInfoResponseDtoToJSONTyped(json, false);
}

export function UpdatePaymentInfoResponseDtoToJSONTyped(value?: UpdatePaymentInfoResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loginUrl': value['loginUrl'],
        'accountId': value['accountId'],
    };
}

